import React, { useState } from "react";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, List, ListItem, ListItemText, Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { ChevronRight } from "@material-ui/icons";
import useStylesExpansionPanel from "../../../hooks/useStylesExpansionPanel";
import InviteDetailsDialog from "./InviteDetailsDialog";

export const InviteListBySituationWithAccordion = ({ data, textBar, defaultOpen, showAgent, canManage, onInviteChanged }) => {
  const [open, setOpen] = useState(!!defaultOpen);
  const [selectedInvite, setSelectedInvite] = useState(null);
  const classes = useStylesExpansionPanel();

  if (!data?.length) return null;

  return (
    <>
      <Accordion
        expanded={open}
        onChange={() => setOpen((prev) => !prev)}
        classes={{ root: classes.root, expanded: classes.expanded }}
        TransitionProps={{ mountOnEnter: true, unmountOnExit: false }}
      >
        <AccordionSummary
          classes={{ root: classes.summary, expanded: classes.expanded, content: classes.content }}
          expandIcon={<ExpandMoreIcon color="primary" />}
        >
          <Typography color="primary" variant="subtitle1">
            <FormattedMessage id={textBar} /> ({data.length})
          </Typography>
        </AccordionSummary>

        <AccordionDetails classes={{ root: classes.content }}>
          <List classes={{ root: classes.list }}>
            {data.map((invite) => (
              <ListItem
                key={invite.id}
                button
                disableGutters
                classes={{ root: classes.listItem }}
                onClick={() => setSelectedInvite(invite)}
              >
                <ListItemText
                  primary={invite.name}
                  secondary={
                    showAgent ? (
                      <FormattedMessage
                        id="app.invite.sentBy.label"
                        values={{
                          email: invite.email,
                          agentName: invite.agent?.name,
                          agentId: invite.agent?.id,
                          agentEmail: invite.agent?.email,
                        }}
                      />
                    ) : (
                      invite.email
                    )
                  }
                />
                <ChevronRight />
              </ListItem>
            ))}
          </List>
        </AccordionDetails>
      </Accordion>

      {selectedInvite && (
        <InviteDetailsDialog
          open
          invite={selectedInvite}
          showAgent={showAgent}
          canManage={canManage}
          onClose={() => setSelectedInvite(null)}
          onChanged={(updatedInvite) => {
            setSelectedInvite(updatedInvite);
            if (onInviteChanged) onInviteChanged(updatedInvite);
          }}
        />
      )}
    </>
  );
};
